import { useCallback } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import type { SignupStep } from '@/pages/signup/utils/steps';
import { splatForStep, stepFromSplat } from '@/pages/signup/utils/steps';
import { parseSignupSearch } from '@/pages/signup/utils/signup-search';
import { SignupRouteGate } from './-signup-route-gate';

export const Route = createFileRoute('/signup/$')({
  validateSearch: parseSignupSearch,
  component: SignupRoute,
});

function SignupRoute() {
  const { _splat } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();

  // The URL is the source of truth for the step, so refresh, browser
  // back/forward, and direct links all land on the right step. The bare
  // /signup is the entry step; unknown segments fall back to it.
  const step = stepFromSplat(_splat);

  const onNavigateStep = useCallback(
    (next: SignupStep) => {
      // Preserve search (signupType/promoCode plus marketing attribution
      // params) across step changes.
      void navigate({ to: '/signup/$', params: { _splat: splatForStep(next) }, search: (prev) => prev });
    },
    [navigate],
  );

  return (
    <SignupRouteGate
      step={step}
      onNavigateStep={onNavigateStep}
      signupType={search.signupType}
      promoCode={search.promoCode}
    />
  );
}
